import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  Todo: {
    color: '#202021',
  },
  icons: {
    marginRight: '5px',
  },
});
